import cx from "clsx";
import { useTranslations } from "next-intl";
import { useState } from "react";

import { ArtworkChecks } from "@/clients/contentful";
import { ArtworkCheckComponent } from "@/features/contentful/components/artwork-check-component/artwork-check-component";
import { useStoreProduct } from "@/features/product/contexts/product-context";
import { formatPrice } from "../hooks/use-price";

export const ProductArtworkCheck = ({ artworkChecks }: { artworkChecks?: ArtworkChecks }) => {
  const t = useTranslations("common");
  const { artworkCheckPrice, pricingResult, setArtworkCheckPrice } = useStoreProduct();
  const [isShowInfo, setIsShowInfo] = useState<boolean>(false);

  const price = formatPrice(pricingResult?.artworkCheck);

  return (
    <div id="ProductArtworkCheck" className="border-grey-30 mt-6 border-b pb-6">
      <h3 className="text-grey-90 text-center text-xl font-semibold md:text-2xl">
        {t("text-artwork-check")}
      </h3>
      <div className="mt-1.5 text-center text-base">{t("text-artwork-check-info")}</div>
      <div className="my-6 flex flex-row flex-nowrap justify-between gap-5">
        <div
          className={cx(
            "basis-[48%] border-grey-50 rounded-lg border p-5 cursor-pointer hover:bg-grey-10 select-none",
            {
              "bg-berry-10 outline-berry-90 outline border-transparent": !artworkCheckPrice,
            },
          )}
          onClick={() => setArtworkCheckPrice(0)}
        >
          <p className="m-0 text-center text-2xl font-semibold"> {t("text-essential")}</p>
          <p className="m-0 text-center">{t("text-essential-points")}</p>
          <p className="mt-4 text-center text-xl font-semibold uppercase leading-none">
            {t("text-free")}
          </p>
        </div>
        <div
          className={cx(
            "basis-[48%] border-grey-50 rounded-lg border p-5 cursor-pointer hover:bg-grey-10 select-none",
            {
              "bg-berry-10 outline-berry-90 outline border-transparent": artworkCheckPrice,
            },
          )}
          onClick={() => setArtworkCheckPrice(pricingResult?.artworkCheck.centAmount)}
        >
          <p className="m-0 text-center text-2xl font-semibold"> {t("text-expert")}</p>
          <p className="m-0 text-center">{t("text-expert-points")}</p>
          <p className="mb-0 mt-4 text-center text-xl font-semibold uppercase leading-none">
            {price}
          </p>
          <p className="m-0 text-center text-sm">
            {t.rich("text-use-print-perk-checkout", {
              b: (text) => <span className="font-bold">{text}</span>,
            })}
          </p>
        </div>
      </div>
      {isShowInfo && artworkChecks && <ArtworkCheckComponent artworkChecks={artworkChecks} />}
      {artworkChecks && (
        <div
          onClick={() => setIsShowInfo(!isShowInfo)}
          className="cursor-pointer text-center italic underline"
        >
          {isShowInfo ? t("text-less-info") : t("text-more-info")}
        </div>
      )}
    </div>
  );
};
